import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import axios from '@utils/request'
import { IOneCountryPayload } from '@app-store/slices/countries/oneCountry'
import { rootActions } from '@app-store/slices'

interface TaskAction extends Action {
    payload: IOneCountryPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.countries.one

function* oneCountrySagaTask({ payload }) {
    try {
        const response = yield axios.get(`/companies/countries/one/${payload.countryId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* oneCountrySaga(): any {
    yield takeLatest<TaskAction>(onRequest, oneCountrySagaTask)
}

export default oneCountrySaga
